import Request from "utils/requests/api";
import initializeConfig from "utils/requests/api.config";

export const BASE_URL_MANAGEMENT = async () => {
  const { management } = await initializeConfig();
  return `${management}`;
};

export interface IRequestReaders {
  _size: number;
  _page: number;
  filter: string;
}

export interface IRequestUpdatedReaderAntennas {
  locationId: number;
  readerNumber: string;
  readerPositionType: string;
  readerIp: string;
  configId: string;
  modelType: string;
  port: number;
  protocol: string;
  status: boolean;
  antennas: [
    {
      antennaNumber: number;
      antennaPort: number;
      antennaPositionType: number;
      flow: number;
      model: string;
      sector: string;
      serieNumber: string;
      status: boolean;
    }
  ];
}

export const getReadersRegister = async ({ _size, _page, filter }: IRequestReaders) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();

  return (await Request).get(`${baseUrlManagement}readers-antennas:paginated`, {
    _size,
    _page,
    filter,
  });
};

export const updateReaderAntennasRegister = async (formData: IRequestReaders) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();

  return (await Request).put(`${baseUrlManagement}readers-antennas`, {
    ...formData,
  });
};

export const createReaderAntennasRegister = async (formData: IRequestReaders) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();

  return (await Request).post(`${baseUrlManagement}readers-antennas`, {
    ...formData,
  });
};

export const getReaderAntennasById = async ({ id }) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).get(`${baseUrlManagement}readers-antennas/${id}`);
};

export const deleteReader = async (readerId: number) => {
  const baseUrlManagement = await BASE_URL_MANAGEMENT();
  return (await Request).delete(`${baseUrlManagement}readers-antennas/?readerId=${readerId}`);
};
